module.exports = __webpack_public_path__ + "img/1.212ac287.png";